export default "__VITE_ASSET__BYlFoNue__"